// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as EventUtils from "../../../library/partner-app-events/EventUtils.bs.js";
import * as Pervasives from "../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as RnrBannerView from "./RnrBannerView.bs.js";
import * as RewardCategory from "../domain/types/RewardCategory.bs.js";
import * as RnrAssetManager from "../assets/RnrAssetManager.bs.js";
import * as RnrRouteManager from "../routing/RnrRouteManager.bs.js";
import ReactIdSwiper from "react-id-swiper";
import * as AwardCardViewCmp from "./AwardCardViewCmp.bs.js";
import * as RnrParamsContext from "../utils/version/RnrParamsContext.bs.js";
import * as DateTime$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as VersionComparator from "../utils/version/VersionComparator.bs.js";
import * as BackButtonComponent from "./BackButtonComponent.bs.js";
import * as RescriptReactRouter from "../../../../node_modules/@rescript/react/src/RescriptReactRouter.bs.js";
import * as RnrAwardDetailModal from "./RnrModalScreens/RnrAwardDetailModal.bs.js";
import * as RnrClaimedRewardModal from "./RnrModalScreens/RnrClaimedRewardModal.bs.js";
import * as RnrMilestoneComponent from "./RnrMilestoneComponent.bs.js";
import * as AwardCardViewComponent from "./AwardCardViewComponent.bs.js";
import * as LinkComponent$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/generic/external-link/LinkComponent.bs.js";
import * as PartnerAppEventsConfig from "../../../library/partner-app-events/PartnerAppEventsConfig.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";
import * as RnRMilestoneAnimationComponent from "./RnRMilestoneAnimationComponent.bs.js";

var customerServiceLogo = RnrAssetManager.getImage("customer_experience_icon.svg");

var loginHoursLogo = RnrAssetManager.getImage("login_activity_icon.svg");

var orderFulfillmentLogo = RnrAssetManager.getImage("order_fulfillment_icon.svg");

var allRewardsClaimedLogo = RnrAssetManager.getImage("allRewardsClaimed_logo.svg");

var noRewardsClaimedLogo = RnrAssetManager.getImage("no_rewards.svg");

var showHistoryIcon = RnrAssetManager.getImage("history_icon.svg");

var giftImage = RnrAssetManager.getImage("gift_box.svg");

var giftIcon = RnrAssetManager.getImage("gift_icon.svg");

var carIcon = RnrAssetManager.getImage("car.svg");

var hcvIcon = RnrAssetManager.getImage("hcv_icon.svg");

var truckIcon = RnrAssetManager.getImage("truck_icon.svg");

function debounce(fn, time) {
  var last = {
    contents: undefined
  };
  return function (v) {
    var t = last.contents;
    if (t !== undefined) {
      clearTimeout(Caml_option.valFromOption(t));
    }
    last.contents = Caml_option.some(setTimeout((function (param) {
                return Curry._1(fn, v);
              }), time));
    
  };
}

function getPointsSection(viewModel, content) {
  return React.createElement("div", {
              className: "pointsSection__container"
            }, React.createElement("div", {
                  className: "pointsSection__title"
                }, content.rnrHome.pointsSectionTitle), React.createElement("div", {
                  className: "pointsSection__current-points"
                }, String(viewModel.cycleAgg.totalPoints)));
}

function getCategoryNavigator(categoryAggList, content) {
  var rnrParams = RnrParamsContext.getRnrParams(undefined);
  return React.createElement("div", {
              className: "categoryNav"
            }, ReasonReactUtils$Catalyst.listToReactArray(List.map((function (categoryAgg) {
                        return React.createElement("div", {
                                    key: RewardCategory.toString(categoryAgg.name),
                                    className: "categoryNav__category-box-container"
                                  }, React.createElement(LinkComponent$Catalyst.make, {
                                        href: RnrRouteManager.RouteManager.getURLFromRoute(rnrParams.auth_token, rnrParams.lang, rnrParams.version, {
                                              TAG: /* RnrReward */2,
                                              _0: rnrParams.uuid,
                                              _1: categoryAgg.name
                                            }),
                                        children: React.createElement("div", {
                                              key: RewardCategory.toString(categoryAgg.name),
                                              className: "categoryNav__category-box",
                                              onClick: (function (param) {
                                                  var match = categoryAgg.name;
                                                  switch (match) {
                                                    case /* CustomerService */0 :
                                                        return EventUtils.sendEventToPartnerApp(PartnerAppEventsConfig.customer_service_card_clicked, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
                                                    case /* LoginActivity */1 :
                                                        return EventUtils.sendEventToPartnerApp(PartnerAppEventsConfig.login_activity_card_clicked, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
                                                    case /* OrderFulfillment */2 :
                                                        return EventUtils.sendEventToPartnerApp(PartnerAppEventsConfig.completed_orders_card_clicked, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
                                                    
                                                  }
                                                })
                                            }, React.createElement("div", {
                                                  className: "categoryNav__category-name"
                                                }, RewardCategory.toDisplayString(categoryAgg.name, content)), React.createElement("div", {
                                                  className: "categoryNav__category-points"
                                                }, String(categoryAgg.points)))
                                      }));
                      }), categoryAggList)));
}

function getSubtitleSection(content) {
  return React.createElement("div", {
              className: "pointsSection__subtitle-row"
            }, React.createElement("div", {
                  className: "pointsSection__subtitle-text"
                }, content.rnrHome.pointsSectionSubtitle), React.createElement("img", {
                  className: "pointsSection__subtitle-img",
                  src: giftImage
                }));
}

function getCategoryAggregateView(viewModel, content) {
  var rnrParams = RnrParamsContext.getRnrParams(undefined);
  return React.createElement("div", {
              className: "home-container__aggView header-background"
            }, React.createElement(BackButtonComponent.make, {
                  className: "home-container__backArrow",
                  onClick: VersionComparator.getIntegerFromAppVersion(rnrParams.version) >= VersionComparator.getAppLinkingMinVersion(undefined) ? (function (prim) {
                        PartnerAppInterface.goBack();
                        
                      }) : (function (prim) {
                        PartnerAppBackNavigator.goBack();
                        
                      })
                }), getPointsSection(viewModel, content), getCategoryNavigator(viewModel.cycleAgg.categoryAggList, content), getSubtitleSection(content), React.createElement(RnrMilestoneComponent.make, {
                  viewModel: viewModel,
                  content: content
                }));
}

function getExpiryInfo(reward, content) {
  var expiryTime = reward.expiryTime;
  if (DateTime$Catalyst.diffDates(DateTime$Catalyst.now(undefined), expiryTime, "hours") >= 24.0) {
    return React.createElement("div", {
                className: "dailyRewardCard__rewards-expiry-bar"
              }, Curry._1(content.getExpiryDateTitle, DateTime$Catalyst.toString("Do MMM", reward.expiryTime)));
  }
  var mins = DateTime$Catalyst.diffDates(DateTime$Catalyst.now(undefined), expiryTime, "minutes");
  return React.createElement("div", {
              className: "dailyRewardCard__rewards-expiry-bar"
            }, Curry._1(content.getExpiryHoursTitle, Math.ceil(mins / 60.0).toString()));
}

function card(reward, content) {
  var match = reward.name;
  switch (match) {
    case /* CustomerService */0 :
        return React.createElement("div", {
                    key: RewardCategory.toString(reward.name),
                    className: "dailyRewardCard__rewards-card dailyRewardCard__card-green"
                  }, React.createElement("img", {
                        className: "dailyRewardCard__rewards-image",
                        src: customerServiceLogo
                      }), React.createElement("div", {
                        className: "dailyRewardCard__rewards-card-name"
                      }, content.category.customerService), getExpiryInfo(reward, content));
    case /* LoginActivity */1 :
        return React.createElement("div", {
                    key: RewardCategory.toString(reward.name),
                    className: "dailyRewardCard__rewards-card dailyRewardCard__card-red"
                  }, React.createElement("img", {
                        className: "dailyRewardCard__rewards-image",
                        src: loginHoursLogo
                      }), React.createElement("div", {
                        className: "dailyRewardCard__rewards-card-name"
                      }, content.category.loginHours), getExpiryInfo(reward, content));
    case /* OrderFulfillment */2 :
        return React.createElement("div", {
                    key: RewardCategory.toString(reward.name),
                    className: "dailyRewardCard__rewards-card dailyRewardCard__card-violet"
                  }, React.createElement("img", {
                        className: "dailyRewardCard__rewards-image",
                        src: orderFulfillmentLogo
                      }), React.createElement("div", {
                        className: "dailyRewardCard__rewards-card-name"
                      }, content.category.orderFulfillment), getExpiryInfo(reward, content));
    
  }
}

function dailyRewards(unclaimedRewards, claimedRewards, content, onClaimReward) {
  return React.createElement("div", undefined, List.length(unclaimedRewards) > 0 ? ReasonReactUtils$Catalyst.listToReactArray(List.map((function (reward) {
                          var rnrParams = RnrParamsContext.getRnrParams(undefined);
                          return React.createElement("div", {
                                      key: DateTime$Catalyst.toString(undefined, reward.date)
                                    }, React.createElement("div", {
                                          className: "dailyRewardRow__rewards-date-title"
                                        }, React.createElement("div", {
                                              className: "dailyRewardRow__rewards-date"
                                            }, DateTime$Catalyst.toString("Do MMM", reward.date))), React.createElement("div", {
                                          className: "dailyRewardRow__rewards-daily-section"
                                        }, ReasonReactUtils$Catalyst.listToReactArray(List.map((function (rewardDetails) {
                                                    return React.createElement("div", {
                                                                key: RewardCategory.toString(rewardDetails.name) + DateTime$Catalyst.toString(undefined, rewardDetails.expiryTime),
                                                                className: "dailyRewardRow__cardHolder",
                                                                onClick: debounce((function (_event) {
                                                                        var date = reward.date;
                                                                        RescriptReactRouter.push(RnrRouteManager.RouteManager.getURLFromRoute(rnrParams.auth_token, rnrParams.lang, rnrParams.version, {
                                                                                  TAG: /* RnrHome */0,
                                                                                  _0: rnrParams.uuid,
                                                                                  _1: RewardCategory.toString(rewardDetails.name),
                                                                                  _2: Caml_option.some(date),
                                                                                  _3: undefined
                                                                                }));
                                                                        return Curry._2(onClaimReward, rnrParams.uuid, rewardDetails.ids);
                                                                      }), 200)
                                                              }, card(rewardDetails, content));
                                                  }), reward.rewards))));
                        }), unclaimedRewards)) : (
                List.length(claimedRewards) > 0 ? React.createElement("div", {
                        className: "dailyRewards__all-rewards-container"
                      }, React.createElement("img", {
                            src: allRewardsClaimedLogo
                          }), React.createElement("div", {
                            className: "dailyRewards__all-rewards-title"
                          }, content.rnrHome.allRewardsClaimedTitle), React.createElement("div", {
                            className: "dailyRewards__all-rewards-text"
                          }, content.rnrHome.allRewardsClaimedText)) : React.createElement("div", {
                        className: "dailyRewards__all-rewards-container"
                      }, React.createElement("img", {
                            src: noRewardsClaimedLogo
                          }), React.createElement("div", {
                            className: "dailyRewards__all-rewards-title"
                          }, content.rnrHome.noRewardsClaimedTitle), React.createElement("div", {
                            className: "dailyRewards__all-rewards-text"
                          }, content.rnrHome.noRewardsClaimedText))
              ));
}

function getCouponAwardCard(award, milestoneDetails, onAwardClick, _content) {
  return React.createElement(AwardCardViewComponent.make, {
              milestoneDetails: milestoneDetails,
              onAwardClick: onAwardClick,
              title: award.coupon_scheme.summary,
              detail: award.coupon_scheme.short_description,
              awardIcon: Belt_Option.mapWithDefault(award.coupon_scheme.rnr_sponsor.logo_url, "", (function (x) {
                      return x;
                    }))
            });
}

function getFuelAwardCard(award, milestoneDetails, onAwardClick, content) {
  return React.createElement(AwardCardViewComponent.make, {
              milestoneDetails: milestoneDetails,
              onAwardClick: onAwardClick,
              title: Curry._1(content.getFuelAwardCardTitle, String(award.fuelQuantity)),
              detail: Curry._1(content.getFuelAwardCardText, String(award.amount))
            });
}

function getPremiumnessAwardCard(award, milestoneDetails, onAwardClick, content) {
  return React.createElement(AwardCardViewComponent.make, {
              milestoneDetails: milestoneDetails,
              onAwardClick: onAwardClick,
              title: Curry._1(content.getPremiumnessAwardCardTitle, String(award.acceptAdvantage)),
              detail: Curry._2(content.getPremiumnessAwardCardText, String(award.acceptAdvantage), DateTime$Catalyst.toString("DD MMM YYYY", award.endDate))
            });
}

function getNoAwardCard(milestoneDetails, onAwardClick, content) {
  return React.createElement(AwardCardViewComponent.make, {
              milestoneDetails: milestoneDetails,
              onAwardClick: onAwardClick,
              title: content.noAward.cardTitle,
              detail: content.noAward.cardText
            });
}

function getMonetaryAwardCard(award, milestoneDetails, onAwardClick, content) {
  return React.createElement(AwardCardViewComponent.make, {
              milestoneDetails: milestoneDetails,
              onAwardClick: onAwardClick,
              title: Curry._1(content.getMonetaryAwardCardTitle, String(award.amount)),
              detail: Curry._1(content.getMonetaryAwardCardText, String(award.amount))
            });
}

function getInsuranceAwardCard(award, milestoneDetails, onAwardClick, content) {
  var match = award.benefit_type;
  return React.createElement(AwardCardViewComponent.make, {
              milestoneDetails: milestoneDetails,
              onAwardClick: onAwardClick,
              title: content.insuranceAward.cardTitle,
              detail: match ? Curry._2(content.getInsuranceAwardCardDiscountText, String(Belt_Option.getWithDefault(award.discount, 0)), DateTime$Catalyst.toString("DD MMM YYYY", award.endDate)) : Curry._2(content.getInsuranceAwardCardText, String(Belt_Option.getWithDefault(award.price, 0)), DateTime$Catalyst.toString("DD MMM YYYY", award.endDate))
            });
}

function getRewardMultiplierAwardCard(award, milestoneDetails, onAwardClick, content) {
  return React.createElement(AwardCardViewComponent.make, {
              milestoneDetails: milestoneDetails,
              onAwardClick: onAwardClick,
              title: Curry._1(content.getRewardMultiplierAwardCardTitle, award.multiplier.toString() + "X"),
              detail: Curry._3(content.getRewardMultiplierAwardCardText, award.multiplier.toString() + "X", DateTime$Catalyst.toString("DD MMM YYYY", award.startDate), DateTime$Catalyst.toString("DD MMM YYYY", award.endDate))
            });
}

function getDistributionCeremonyAwardCard(milestoneDetails, onAwardClick, content) {
  return React.createElement(AwardCardViewComponent.make, {
              milestoneDetails: milestoneDetails,
              onAwardClick: onAwardClick,
              title: content.distributionCeremonyAward.cardTitle,
              detail: content.distributionCeremonyAward.cardText
            });
}

function getFinalAwardCard(milestoneDetails, onAwardClick, content) {
  return React.createElement(AwardCardViewComponent.make, {
              milestoneDetails: milestoneDetails,
              onAwardClick: onAwardClick,
              title: content.finalAward.cardTitle,
              detail: content.finalAward.cardText
            });
}

function getAwardCard(milestoneDetails, content, onAwardClick, banners, vehicleCategory) {
  var award = milestoneDetails.awardDisplay;
  var awardBanner;
  if (typeof award === "number") {
    switch (vehicleCategory) {
      case /* LCV */0 :
          awardBanner = React.createElement(AwardCardViewCmp.make, {
                milestoneDetails: milestoneDetails,
                onAwardClick: onAwardClick,
                modal_title: content.defaultLCVAward.modalTitle,
                icon: undefined
              });
          break;
      case /* HCV */1 :
          awardBanner = React.createElement(AwardCardViewCmp.make, {
                milestoneDetails: milestoneDetails,
                onAwardClick: onAwardClick,
                modal_title: content.defaultHCVAward.modalTitle,
                icon: undefined
              });
          break;
      case /* TwoWheeler */2 :
          awardBanner = React.createElement(AwardCardViewCmp.make, {
                milestoneDetails: milestoneDetails,
                onAwardClick: onAwardClick,
                modal_title: content.default2WAward.modalTitle,
                icon: undefined
              });
          break;
      
    }
  } else {
    switch (award.TAG | 0) {
      case /* Fuel */0 :
          awardBanner = getFuelAwardCard(award._0, milestoneDetails, onAwardClick, content);
          break;
      case /* Premiumness */1 :
          awardBanner = getPremiumnessAwardCard(award._0, milestoneDetails, onAwardClick, content);
          break;
      case /* RewardMultiplier */2 :
          awardBanner = getRewardMultiplierAwardCard(award._0, milestoneDetails, onAwardClick, content);
          break;
      case /* NoAward */3 :
          awardBanner = getNoAwardCard(milestoneDetails, onAwardClick, content);
          break;
      case /* Monetary */4 :
          awardBanner = getMonetaryAwardCard(award._0, milestoneDetails, onAwardClick, content);
          break;
      case /* Insurance */5 :
          awardBanner = getInsuranceAwardCard(award._0, milestoneDetails, onAwardClick, content);
          break;
      case /* DistributionCeremony */6 :
          awardBanner = getDistributionCeremonyAwardCard(milestoneDetails, onAwardClick, content);
          break;
      case /* Final */7 :
          awardBanner = getFinalAwardCard(milestoneDetails, onAwardClick, content);
          break;
      case /* Coupon */8 :
          awardBanner = getCouponAwardCard(award._0, milestoneDetails, onAwardClick, content);
          break;
      
    }
  }
  var banners$1 = RnrBannerView.getBanners(banners, "");
  if (List.length(banners$1) > 0) {
    return React.createElement(ReactIdSwiper, {
                wrapperClass: "banners-wrapper",
                containerClass: "banners-container",
                slideClass: "banner-slide",
                children: $$Array.of_list(List.mapi((function (ind, banner) {
                            return React.createElement("div", {
                                        key: String(ind)
                                      }, banner);
                          }), Pervasives.$at({
                              hd: awardBanner,
                              tl: /* [] */0
                            }, banners$1))),
                autoplay: {
                  delay: 3000,
                  disableOnInteraction: true
                },
                pagination: {
                  el: ".swiper-pagination",
                  clickable: true,
                  dynamicBullets: false
                }
              });
  } else {
    return awardBanner;
  }
}

function getDailyRewardsView(viewModel, content, onClaimReward) {
  return React.createElement("div", {
              className: "dailyRewards"
            }, React.createElement("div", {
                  className: "dailyRewards__rewards-section"
                }, React.createElement("div", {
                      className: "dailyRewards__rewards-title-section"
                    }, content.rnrHome.dailyRewardsHeader, React.createElement("div", {
                          className: "dailyRewards__rewards-title-separator"
                        })), React.createElement("div", {
                      className: "dailyRewards__rewards-claim-section"
                    }, dailyRewards(viewModel.unclaimedRewards, viewModel.claimedRewards, content, onClaimReward))));
}

function getFooter(content) {
  var rnrParams = RnrParamsContext.getRnrParams(undefined);
  return React.createElement("div", {
              className: "historyPageNav",
              onClick: (function (param) {
                  return EventUtils.sendEventToPartnerApp(PartnerAppEventsConfig.rewards_and_gift_history_clicked, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
                })
            }, React.createElement(LinkComponent$Catalyst.make, {
                  href: RnrRouteManager.RouteManager.getURLFromRoute(rnrParams.auth_token, rnrParams.lang, rnrParams.version, {
                        TAG: /* RewardHistory */1,
                        _0: rnrParams.uuid,
                        _1: undefined,
                        _2: undefined
                      }),
                  className: "historyPageNav__rewards-history-button",
                  children: React.createElement("div", {
                        className: "historyPageNav__rewards-history-button-content"
                      }, React.createElement("img", {
                            src: showHistoryIcon
                          }), React.createElement("div", {
                            className: "historyPageNav__rewards-history-button-text"
                          }, content.rnrHome.rewardHistoryFooterText), React.createElement("div", {
                            className: "historyPageNav__rewards-history-button-arrow"
                          }, ">"))
                }));
}

function getView(viewModel, content, refreshView, showRewardModal, showAwardModal, showConfetti, selectedDate, selectedCategory, onRewardToggle, onClaimReward, onAwardClick, requestState, bannersState) {
  return React.createElement("div", {
              className: "home-container"
            }, getCategoryAggregateView(viewModel, content), React.createElement(RnRMilestoneAnimationComponent.make, {
                  showConfetti: showConfetti,
                  _showRewardModal: showRewardModal,
                  _refreshView: refreshView
                }), getAwardCard(viewModel.milestoneDetails, content, onAwardClick, bannersState, viewModel.vehicleCategory), getDailyRewardsView(viewModel, content, onClaimReward), getFooter(content), showRewardModal ? React.createElement(RnrClaimedRewardModal.make, {
                    rewards: viewModel.unclaimedRewards,
                    content: content,
                    selectedDate: selectedDate,
                    selectedCategory: selectedCategory,
                    onRewardToggle: onRewardToggle,
                    requestState: requestState
                  }) : null, showAwardModal ? React.createElement(RnrAwardDetailModal.make, {
                    milestone: viewModel.milestoneDetails.currentMilestone,
                    viewModel: viewModel,
                    content: content
                  }) : null);
}

var RnrHomeViewMapper = {
  getView: getView
};

export {
  customerServiceLogo ,
  loginHoursLogo ,
  orderFulfillmentLogo ,
  allRewardsClaimedLogo ,
  noRewardsClaimedLogo ,
  showHistoryIcon ,
  giftImage ,
  giftIcon ,
  carIcon ,
  hcvIcon ,
  truckIcon ,
  RnrHomeViewMapper ,
  
}
/* customerServiceLogo Not a pure module */
